import { getDangerList } from '../api/common';

const actions = {
  async _getDangerList({ commit }) {
    const data = await getDangerList();
    commit('SET_DANGERLIST', data.body.data)
    return Promise.resolve(data.body.data);
  },
}

export default actions